import { Box } from 'rebass';
import AvatarEditor from './AvatarEditor';
import { useEffect, useState } from 'react';
import BufferingOverlay from 'app/modal/BufferingOverlay';

function ImageUploader({
    src,
    scale,
    width,
    height,
    photoScaling,
    onImageSelection,
    setPhotoScalling,
    setScale,
    setFile,
    frameSrc,
    onImageDeletion,
    isSubmitting,
    setSubmitting
}) {
    const [isEditing, setIsEditing] = useState(!!src);
    const [file, setNewFile] = useState(src);

    useEffect(() => {
        setIsEditing(!!src)
        setNewFile(src)
    }, [src])

    return (
        <BufferingOverlay isBuffering={isSubmitting} color="#fff">
            <Box maxWidth="450px" m="auto" mb={['80px', 3]} textAlign="center">
                <AvatarEditor
                    onDismiss={isEditing || !src ? null : () => setIsEditing(true)}
                    setIsEditing={setIsEditing}
                    setSubmitting={setSubmitting}
                    src={isEditing ? file : null}
                    setFile={isEditing ? null : setNewFile}
                    frameSrc={frameSrc}
                    posterAttributes={{
                        position: photoScaling,
                        scale,
                        aspectRatio: { width, height },
                    }}
                    onImageDeletion={onImageDeletion}
                    onAccept={(val) => {
                        const { scale: newScaleValue, position } = val;
                        setPhotoScalling({ x: position?.x || 0, y: position?.y || 0 });
                        setScale(+newScaleValue);
                        if (isEditing) {
                            onImageSelection(val);
                        } else if (file && file.type.includes('image') && !isEditing) {
                            onImageSelection(val, file);
                            setFile(file);
                        }
                    }}
                />
            </Box>
        </BufferingOverlay>
    );
}

export default ImageUploader;